import React from 'react';
import { Row as RCRow, RowProps as RowPropsBase } from 'react-grid-system';
import classnames from 'classnames';

interface RowProps extends Omit<RowPropsBase, 'gutterWidth'> {
  gutter?: [number, number] | number;
}

const Row = (props: RowProps, ref?: React.Ref<HTMLDivElement>) => {
  const { gutter, style, className } = props;
  const gutters =
    typeof gutter === 'number' ? [gutter, gutter] : Array.isArray(gutter) ? gutter : [0, 0];

  // Add gutter related style
  const horizontalGutter = gutters[0] ?? 0;
  const verticalGutter = gutters[1] ?? undefined;
  const rowStyle: React.CSSProperties = {
    ...style,
    rowGap: verticalGutter,
    gridRowGap: verticalGutter,
  };

  return (
    <RCRow
      {...props}
      ref={ref as any}
      gutterWidth={horizontalGutter}
      style={rowStyle}
      className={classnames('ui-row', className)}
    />
  );
};

export default React.forwardRef(Row);
